import { render, staticRenderFns } from "./completed-students.vue?vue&type=template&id=1c4d2608&scoped=true&"
import script from "./completed-students.vue?vue&type=script&lang=js&"
export * from "./completed-students.vue?vue&type=script&lang=js&"
import style0 from "./completed-students.vue?vue&type=style&index=0&id=1c4d2608&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4d2608",
  null
  
)

component.options.__file = "completed-students.vue"
export default component.exports